import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import cc from 'classcat';
import PropTypes from 'prop-types';
import Button from '../Button';
import Image from '../Image';
import css from './DoerBlock.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var DoerBlock = function DoerBlock(_ref) {
  var cta = _ref.cta,
      image = _ref.image,
      isImageLeft = _ref.isImageLeft,
      message = _ref.message,
      onClickCta = _ref.onClickCta,
      title = _ref.title;
  return /*#__PURE__*/_jsxs("section", {
    className: cc([css.root, _defineProperty({}, css.imageLeft, isImageLeft)]),
    children: [/*#__PURE__*/_jsx("div", {
      className: css.copy,
      children: /*#__PURE__*/_jsxs("div", {
        className: css.copyInner,
        children: [/*#__PURE__*/_jsx("h3", {
          className: css.title,
          children: title
        }), /*#__PURE__*/_jsx("p", {
          className: css.message,
          children: message
        }), /*#__PURE__*/_jsx(Button, {
          medium: true,
          className: css.cta,
          onClick: onClickCta,
          children: cta
        })]
      })
    }), /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, image), {}, {
      className: css.image
    }))]
  });
};

DoerBlock.defaultProps = {
  onClickCta: function onClickCta() {}
};
DoerBlock.propTypes = {
  cta: PropTypes.string.isRequired,
  image: PropTypes.shape(_objectSpread({}, Image.propTypes)).isRequired,
  isImageLeft: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  onClickCta: PropTypes.func,
  title: PropTypes.string.isRequired
};
export default DoerBlock;